// extracted by mini-css-extract-plugin
export default {"container":"PausableTariff_container__8eWTD","row":"PausableTariff_row__9RkHU","title":"PausableTariff_title__4N1YI"};